import { useMemo } from 'react';
import useToothPathology from './Pathology/useToothPathology';
import useToothPeriodontal from './Periodontal/useToothPeriodontal';
import useToothRestoration from './Restoration/useToothRestoration';
import useToothEndodontic from './Endodontic/useToothEndodontic';

export default function useTooth() {
	const { pathology } = useToothPathology();
	const { periodontal } = useToothPeriodontal();
	const { restoration } = useToothRestoration();
	const { endodontic } = useToothEndodontic();

	return useMemo(
		() => ({
			pathology,
			periodontal,
			restoration,
			endodontic,
		}),
		[pathology, periodontal, restoration, endodontic],
	);
}
